import React from 'react'
import {getFetcher, wrapLazy} from '@startlibs/utils'

export const lazyRecords = wrapLazy((caseId, patientUID) =>
  (caseId
    ? getFetcher(`/case/${encodeURIComponent(caseId)}`,patientUID ? {patientUID} : undefined)
    : getFetcher(`/record/patient/${patientUID}`)
  )
)
